const CURRENT_LOCATION = {
  // タイミング・閾値
  // 位置情報取得の最大待ち時間（ミリ秒）
  buttonResetMs: 15000,
  // これより新しいキャッシュがあればそれを使う（ミリ秒）
  maximumAgeMs: 30000,
  // 現在地ボタンを通常状態に戻すまでの時間（ミリ秒）
  buttonResetDelayMs: 3000,
  // グレー円のフェードアウト開始遅延（ミリ秒）
  feedbackFadeoutDelayMs: 2000,
  // グレー円のフェードアウト間隔（ミリ秒）
  feedbackFadeoutIntervalMs: 50,
  // グレー円の初期透明度
  feedbackInitialOpacity: 0.4,
  // グレー円のストローク初期透明度
  feedbackInitialStrokeOpacity: 0.6,
  // グレー円の透明度減少量（間隔ごと）
  feedbackOpacityDecrement: 0.04,
  // グレー円のストローク透明度減少量（間隔ごと）
  feedbackStrokeOpacityDecrement: 0.06,
  // 地図移動時のズームレベル
  targetZoom: 16,
  // 精度円を表示する閾値（メートル）
  accuracyThreshold: 100,

  // マーカー描画スタイル
  markerStyles: {
    // フィードバック円（測位完了時の一時的な円）
    feedback: {
      radius: 50,
      color: '#888888',
      opacity: 0.4,
      strokeWidth: 2,
      strokeColor: '#aaaaaa',
      strokeOpacity: 0.6
    },

    // 現在地マーカー（青い円）
    currentLocation: {
      radius: 10,
      color: '#1976D2',
      strokeWidth: 3,
      strokeColor: '#ffffff',
      opacity: 0.9
    },

    // 精度円（位置精度が低い場合に表示）
    accuracy: {
      color: '#1976D2',
      opacity: 0.1
    }
  },

  // ユーザー向けメッセージ
  messages: {
    // Geolocation API エラーメッセージ（エラーコード別）
    geolocation: {
      "1": "位置情報の利用が許可されていません。\nブラウザの設定で位置情報を許可してください。",
      "2": "現在位置が取得できませんでした。\n屋外や窓際で再度お試しください。",
      "3": "位置情報の取得がタイムアウトしました。\n電波の良い場所で再度お試しください。"
    },
    // ブラウザが Geolocation API に非対応の場合
    noGeolocation: "このブラウザでは位置情報が取得できません。"
  }
};

export default CURRENT_LOCATION;